<template>
  <Card>
    <p slot="title">资金商仓库列表</p>
    <template slot="extra">
      <Button
        type="primary"
        icon="md-add"
        @click="addAction()"
        v-access="'wareList.add'"
        >添加</Button
      >
      <Button type="primary" icon="md-add" @click="importAction()"
        >导入仓库</Button
      >
      <Button type="primary" icon="md-add" @click="exportAction()"
        >导出仓库</Button
      >
      <Button
        type="primary"
        icon="md-sync"
        @click="reset()"
        v-access="'wareList.reset'"
        >刷新</Button
      >
    </template>
    <Row>
      <Col span="18">
        <Input
          v-model="wmsName_code"
          placeholder="请输入仓库名称/编码"
          class="public-inp"
        />
        <Input
          v-model="spCode_name"
          placeholder="请输入资金商名称/编码"
          class="public-inp"
        />
        <Select v-model="status" placeholder="请选择状态" class="public-inp">
          <Option value="">全部</Option>
          <Option value="0">待配置</Option>
          <Option value="1">启用</Option>
          <Option value="2">禁用</Option>
        </Select>
      </Col>
      <Col span="6">
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'wareList.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ (page - 1) * pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row, index }" slot="status">
            <i-switch
              v-access="'wareList.status'"
              :disabled="row.status == 0"
              :value="row.status == 1"
              @on-change="(v) => stateChange(v, row, index)"
              size="small"
            />
          </template>
          <template slot-scope="{ row }" slot="action">
            <!-- 0 待配置 -->
            <div v-show="row.status == 0">
              <a
                href="javascript:;"
                @click="openFn(row, 2)"
                v-access="'wareList.edit'"
                >配置</a
              >
              <a
                href="javascript:;"
                @click="openFn(row, 1)"
                v-access="'wareList.edit'"
                >编辑</a
              >
            </div>
            <!--	1：启用+2：禁用-->
            <div v-show="row.status == 1 || row.status == 2">
              <a
                href="javascript:;"
                @click="openFn(row, 1)"
                v-access="'wareList.edit'"
                >编辑</a
              >
              <a
                href="javascript:;"
                @click="openFn(row, 2)"
                v-access="'wareList.details'"
                >查看</a
              >
            </div>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="pageSize"
          :current="page"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    fixed: "left",
    width: 66,
  },
  {
    title: "资金商",
    key: "spName",
    width: 100,
  },
  {
    title: "仓库名称",
    key: "wmsName",
    width: 120,
  },
  // {
  //   title: "ERP系统出库仓库编号",
  //   key: "wmsCode",
  //   width: 160,
  // },
  {
    title: "送达方编码",
    key: "shipToCode",
    width: 100,
  },
  {
    title: "送达方名称",
    key: "shipToName",
    width: 100,
  },
  // {
  //   title: "经销商名称",
  //   key: "spName",
  //   width: 100,
  // },
  {
    title: "资金商编码",
    key: "spCode",
    width: 100,
  },
  {
    title: "三方仓库编码",
    key: "thirdPartyCode",
    width: 100,
  },
  {
    title: "发货区域",
    key: "wmsAddressInfo",
    width: 300,
    render(h, params) {
      if (params.row.wmsAddressInfo) {
        let p = params.row.wmsAddressInfo;
        return h(
          "div",
          p.provinceName + p.cityName + p.countyName + p.streetName
        );
      }
    },
  },
  {
    title: "仓库地址",
    key: "wmsAddressInfo",
    width: 100,
    render(h, params) {
      if (params.row.wmsAddressInfo) {
        let p = params.row.wmsAddressInfo;
        return h("div", p.address);
      }
    },
  },
  {
    title: "状态",
    slot: "status",
    width: 100,
  },

  //   {
  //     title: "接收系统账号",
  //     key: "receivedAccount",
  //     width: 120,
  //   },
  //   {
  //     title: "接收系统编号",
  //     key: "receivedCode",
  //     width: 120,
  //   },
  //   {
  //     title: "特征参数[渝欧海拍客]",
  //     key: "featureArgs",
  //     width: 160,
  //   },
  {
    title: "修改时间",
    key: "updatetime",
    width: 150,
  },
  // {
  //   title: "创建时间",
  //   key: "createtime",
  //   width: 150,
  // },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    width: 130,
  },
];
export default {
  data() {
    return {
      wmsName_code: "", //仓库编码或名称
      spCode_name: "", //资金商编码或名称
      wmsName: "",
      wmsCode: "",
      spCode: "",
      spName: "",
      status: "",
      page: 1,
      pageSize: 10,
      total: 0,
      columns,
      tbList: [],
      loading: false,
    };
  },
  filters: {},
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        wmsName: this.wmsName_code,
        wmsCode: this.wmsName_code,
        spCode: this.spCode_name,
        spName: this.spCode_name,
        status: this.status,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.wareSearch(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.wmsName_code = "";
      this.spCode_name = "";
      this.status = "";
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    addAction() {
      this.$router.replace({ path: "/wareAdd" });
    },
    importAction() {
      this.$router.replace({ path: "/wareImport" });
    },
    openFn(d, i) {
      let query = {
        shipToCode: d.shipToCode,
        spCode: d.spCode,
        wmsCode: d.wmsCode,
      };
      let path = i == 1 ? "/wareAdd" : "/wareDetail";
      this.$router.replace({ path, query });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 状态
    stateChange(v, d, i) {
      let http = d.status == 1 ? "wareDisable" : "wareEnable";
      let params = {
        shipToCode: d.shipToCode,
        spCode: d.spCode,
        wmsCode: d.wmsCode,
      };
      this.$api[http](params).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
    exportAction() {
      let data = {
        wmsName: this.wmsName_code,
        wmsCode: this.wmsName_code,
        spCode: this.spCode_name,
        spName: this.spCode_name,
        status: this.status,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$api.batchExport(data).then((res) => {
        if (res.code == "200") {
          try {
            let elemIF = document.createElement("iframe");
            elemIF.src = res.data.url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            this.$Message.error("下载异常！");
          }
        } else {
          this.$Message.error("导出失败" + res.message);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/warehouse/wareList.vue